import projectsRoutingKeys from "Areas/Projects/routingKeys";
import { routesAndPagesMap } from "Common/routingUtils";
import { connect } from "react-redux";
import ProjectDetails from "./projectDetails";
const getProjectDetailsHref = (projectId) => routesAndPagesMap.getPath(projectsRoutingKeys.PROJECT_DETAILS, projectId);
const mapStateToProps = () => ({
    getProjectDetailsHref
});
export default connect(mapStateToProps)(ProjectDetails);
